/*
 * @Description:全局状态管理
 * @Author: kai.zhou
 * @Date: 2020-03-25 14:39:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2026-03-30 17:49:33
 */
import { createStore, combineReducers } from "redux";

const PHONE = "PHONE";
//定义初始化数据
const initData = {
  //是否展示title，来自官网就不展示
  ispc: false,
  //国家
  countryList: [],
  countryActive: {
    // "name": "India",
    // "mcc": "404",
    // "hotline": "18004190525",
    // "code": "IN",
    // "areaCode": "91"
  },
  countryActiveMcc: '',
  //图片路径
  imgUrl: "",
  //机型
  model: {
    leftName: "", //品牌
    leftCode: "",
    rightName: "", //机型
    rightCode: "",
    middleCode:'',//子品牌
  },
  keyword: "",
  //问题描述
  problems: "",
  //客户信息
  infoName: "",
  infoPhone: "",
  //店铺信息
  shopMessage: {
    storeName: "",
    storeCode: "",
    storeAddr: "",
    latitude: "",
    longitude: "",
  },
  //预约时间
  time: [], //["2020-06-18", "09:00-10:00"]
  //寄修业务
  isDeliveryArea: false,//是否为寄修服务区域 寄修国家：泰国520 印尼510）
  isDeliverySite: 0,//是否寄修服务 0普通 1寄修  2上门 3智能柜
  deliveryAreaLength: 0,//寄修区域长度
  deliveryAddrees1: "",//上门邮寄地址
  deliveryAddcode1: "",//上门邮寄地址邮编
  postalCodeList: [],//上门邮寄地址邮编列表
  needDeliveryAddrees2: false,//是否添加返寄回地址
  deliveryAddrees2: "",//返寄回地址
  deliveryAddcode2: "",//返寄回地址邮编
  deliveryFaulttype: [],//寄修破损类型
  // 泰国独立业务
  proList: [],//省份列表
  thpro: {},//泰国省份
  // 印尼业务
  cityshow: false,//城市
  citylists: [],//印尼城市列表
  cityname: {},//印尼城市名称
  latlong: ['',''],//定位
  // 物流订单查询后的数据缓存
  idwuliulist:[],
  onSiteService:false,//是否支持上门服务
  onSiteList:[],//上门服务地区列表
  onSiteCity:{},//上门服务的地区
  smartService:false,//是否支持快递柜服务
  smartList:[],//支持快递柜服务的地区
  haveFaultType:false,//到店服务是否有FaultType
  goHomeServiceName:'',//上门文案
};
//定义dispatch调用的action
//机型选择
export const chooseModel = (v: any) => {
  return { type: "chooseModel", data: v };
};
//设置关键字
export const setKey = (v: any) => {
  return { type: "setKey", data: v };
};
//问题描述
export const setProblems = (v: any) => {
  return { type: "setProblems", data: v };
};
//banner图片
export const getBannerImg = (v: any) => {
  return { type: "getBannerImg", data: v };
};
//国家列表
export const getCountryList = (v: any) => {
  return { type: "getCountryList", data: v };
};
//选中国家
export const setCountryActive = (v: any) => {
  return { type: "setCountryActive", data: v };
};
//寄修服务区域长度
export const setdeliveryAreaLength = (v: any) => {
  return { type: "setdeliveryAreaLength", data: v };
};
//客户姓名
export const setName = (v: any) => {
  return { type: "name", data: v };
};
//客户手机
export const setPhone = (v: any) => {
  return { type: PHONE, data: v };
};
//店铺信息
export const setShop = (v: any) => {
  return { type: "setShop", data: v };
};
//预约时间
export const setTime = (v: any) => {
  return { type: "setTime", data: v };
};
//预约时间
export const setpc = (v: any) => {
  return { type: "setpc", data: v };
};
//寄修业务
export const setDeliver = (v: any) => {
  if (v.type === 1) {
    return { type: "setisDeliveryArea", data: v.data };
  } else if (v.type === 2) {
    let oisDeliverySite=getStore().defaultState?.isDeliverySite||0;
    let omodel=getStore().defaultState?.model||{
      leftName: "", //品牌
      leftCode: "",
      rightName: "", //机型
      rightCode: "",
      middleCode:'',//子品牌
    }
    
    return { type: "setisDeliverySite", data: {
      v1:v.data,
      model:(v.data===2||oisDeliverySite===2)?{//前一次和现一次，出现上门就清理机型数据
        leftName: "", leftCode: "",rightName: "", rightCode: "",middleCode:'',
      }:omodel
    }};
  } else if (v.type === 3) {
    return { type: "setdeliveryAddrees1", data: v.data };
  } else if (v.type === 4) {
    return { type: "setdeliveryAddcode1", data: v.data };
  } else if (v.type === 5) {
    return { type: "setneedDeliveryAddrees2", data: v.data };
  } else if (v.type === 6) {
    return { type: "setdeliveryAddrees2", data: v.data };
  } else if (v.type === 7) {
    return { type: "setdeliveryAddcode2", data: v.data };
  } else if (v.type === 8) {
    return { type: "setdeliveryFaulttype", data: v.data };
  }
};
// 泰国省份
export const setThpro = (v: any) => {
  return { type: "setThpro", data: v };
}
// 省份列表
export const setProList = (v: any) => {
  return { type: "setProList", data: v };
}
//城市
export const setcityshow = (v: any) => {
  return { type: "setcityshow", data: v };
};
//印尼城市列表
export const setcitylists = (v: any) => {
  return { type: "setcitylists", data: v };
};
//印尼城市名称
export const setcityname = (v: any) => {
  return { type: "setcityname", data: v };
};
//印尼城市名称
export const setlatlong = (v: any) => {
  return { type: "setlatlong", data: v };
};
//物流订单查询后的数据缓存
export const setidwuliulist = (v: any) => {
  return { type: "setidwuliulist", data: v };
};
//上门服务省份列表
export const setonSiteList = (v: any) => {
  return { type: "setonSiteList", data: v };
};
//上门服务地区
export const setonSiteCity = (v: any) => {
  return { type: "setonSiteCity", data: v };
};
// //上门服务是否支持
// export const setonSiteService = (v: any) => {
//   return { type: "setonSiteService", data: v };
// };
// //智能柜服务是否支持
// export const setsmartService = (v: any) => {
//   return { type: "setsmartService", data: v };
// };
//上门服务是否支持，智能柜服务是否支持，到店是否有faulttype
export const setnewService = (v: any) => {
  return { type: "setnewService", data: v };
};
//智能柜服务省份列表
export const setsmartList = (v: any) => {
  return { type: "setsmartList", data: v };
};
//上门邮寄地址邮编列表
export const setPostalCodeList = (v: any) => {
  return { type: "setPostalCodeList", data: v };
};

//定义action触发state改变
const defaultState = (state: any = initData, action: any) => {
  switch (action.type) {
    case "chooseModel": //机型选择
      return { ...state, ...{ model: action.data } };
    case "setKey": //机型选择
      return { ...state, ...{ keyword: action.data } };
    case "setProblems": //问题描述
      return { ...state, ...{ problems: action.data } };
    case "getBannerImg": //banner图片
      return { ...state, ...{ imgUrl: action.data } };
    case "getCountryList": //国家列表
      return { ...state, ...{ countryList: action.data } };
    case "setCountryActive": //选中国家
      return { ...state, ...{ countryActive: action.data, countryActiveMcc: action.data.mcc } };
    case "name": //客户姓名
      return { ...state, ...{ infoName: action.data } };
    case PHONE: //客户手机
      return { ...state, ...{ infoPhone: action.data } };
    case "setShop": //店铺信息
      return { ...state, ...{ shopMessage: action.data } };
    case "setTime": //店铺信息
      return { ...state, ...{ time: action.data } };
    case "setpc": //是否官网展示
      return { ...state, ...{ ispc: action.data } };
    case "setdeliveryAreaLength": 
      return { ...state, ...{ deliveryAreaLength: action.data } };
    case "setisDeliveryArea": //是否为寄修服务区域 泰国520 印尼510
      return {
        ...state, ...{
          isDeliveryArea: action.data,
          isDeliverySite: 1,//是否寄修服务 
          deliveryAddrees1: "",//上门邮寄地址
          deliveryAddcode1: "",//上门邮寄地址邮编
          needDeliveryAddrees2: false,//是否添加返寄回地址
          deliveryAddrees2: "",//返寄回地址
          deliveryAddcode2: "",//返寄回地址邮编
          deliveryFaulttype: [],//寄修破损类型 
        }
      };
    case "setisDeliverySite": //是否寄修服务
      return { ...state, ...{ isDeliverySite: action.data.v1,model:action.data.model } };
    case "setdeliveryAddrees1": //上门邮寄地址
      return { ...state, ...{ deliveryAddrees1: action.data } };
    case "setdeliveryAddcode1": //上门邮寄地址邮编
      return { ...state, ...{ deliveryAddcode1: action.data } };
    case "setneedDeliveryAddrees2": //是否添加返寄回地址
      return { ...state, ...{ needDeliveryAddrees2: action.data } };
    case "setdeliveryAddrees2": //返寄回地址
      return { ...state, ...{ deliveryAddrees2: action.data } };
    case "setdeliveryAddcode2": //返寄回地址邮编
      return { ...state, ...{ deliveryAddcode2: action.data } };
    case "setdeliveryFaulttype": //寄修bug类型
      return { ...state, ...{ deliveryFaulttype: action.data } };
    case "setThpro": //寄修省份
      return { ...state, ...{ thpro: action.data } };
    case "setProList": //寄修省份列表
      return { ...state, ...{ proList: action.data } };
    case "setcityshow": //城市
      return { ...state, ...{ cityshow: action.data } };
    case "setcitylists": //印尼城市列表
      return { ...state, ...{ citylists: action.data } };
    case "setcityname": //选择城市名称
      return { ...state, ...{ cityname: action.data } };
    case "setlatlong": //经纬度
      return { ...state, ...{ latlong: action.data } };
    // 物流订单查询后的数据缓存
    case "setidwuliulist":
      return { ...state, ...{ idwuliulist: action.data }}; 
    case "setonSiteList":
      return { ...state, ...{ onSiteList: action.data }}; 
    case "setonSiteCity":
        return { ...state, ...{ onSiteCity: action.data }}; 
    // case "setonSiteService":
    //     return { ...state, ...{ onSiteService: action.data }};   
    // case "setsmartService":
    //   return { ...state, ...{ smartService: action.data }}; 
    case "setnewService":
      return { ...state, ...{ 
        onSiteService: action.data.onSiteService,
        smartService: action.data.smartService,
        haveFaultType: action.data.haveFaultType,
        goHomeServiceName: action.data.goHomeServiceName,
      }}; 
    case "setsmartList":
      return { ...state, ...{ smartList: action.data }};    
    case "setPostalCodeList":
      return { ...state, ...{ postalCodeList: action.data }};
    default:
      return state;
  }
};

// 全局你可以创建多个reducer 在这里统一在一起
const defaultStore = combineReducers({ defaultState });
// 全局就管理一个store
export const store = createStore(defaultStore);

//获取自身数据
function getStore(){
  return (store.getState())||{}
}